import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { LIMITS, RETAIL_INPUTS } from '../../../_shared/constants/retail';

import { TextArea, TextAreaCounter } from './Styles';

const Notes = React.forwardRef((props, ref) => {
  const intl = useIntl();
  const [descCharsLeft, setDescCharsLeft] = useState(LIMITS.NOTES);

  const onCustomizationChange = e => {
    const { value } = e.currentTarget;

    // Slice off all characters after 4096
    if (value.length > LIMITS.NOTES) {
      e.currentTarget.value = value.slice(0, LIMITS.NOTES);
    }

    setDescCharsLeft(LIMITS.NOTES - e.currentTarget.value.length);
  };

  return (
    <>
      <TextArea
        id={RETAIL_INPUTS.NOTES}
        placeholder={intl.formatMessage({
          id: 'vdp.retail.description.placeholder'
        })}
        onChange={onCustomizationChange}
        maxLength={LIMITS.NOTES}
        ref={ref}
        data-testid="retailCust-notes"
      />
      <TextAreaCounter data-testid="retailCust-notes-counter">
        {descCharsLeft}/{LIMITS.NOTES}
      </TextAreaCounter>
    </>
  );
});

export default Notes;
